<div id="top" class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">
        Perte/Vol @if (validation != '0') {
        <span>({{ step }}/{{ steps }})</span>
    }
    </div>
</div>
@if (procedureStatus == 'finished' && step == 1) {
    <div>
        <div class="col-12">
            Cette déclaration de perte ou vol va entraîner la suspension de votre ligne et la commande d'une nouvelle
            SIM.
            <br>
            <div class="row w-100 pt-3 text-center">
                <div class="col-12 w-100 cta_container">
                    <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                    <button type="button" class="cta_btn level_2 column" (click)="setStep(2)">Suivant<span></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
}
@if (procedureStatus == 'wait_form' && step == 1) {
    <div>
        <div class="col-12">
            Suite à votre déclaration de perte/vol, votre ligne <strong>{{ line.phoneNumber }}</strong> a été suspendue.
            Pour commander une nouvelle SIM, il faut confirmer votre déclaration de perte/vol. Si vous l'annulez, votre
            ligne sera automatiquement remise en service dans sous 24h.
            <br><br>
            <div class="form-group pl-3">
                <div class=" form-check-inline">
                    <input class="form-check-input" type="radio" id="confirmation1" name="validation"
                           [(ngModel)]="validation" value="0">
                    <label class="form-check-label" for="confirmation1">
                        J'annule ma déclaration de perte/vol
                    </label>
                </div>
                <br>
                <div class=" form-check-inline">
                    <input class="form-check-input" type="radio" id="confirmation2" name="validation"
                           [(ngModel)]="validation" value="1">
                    <label class="form-check-label" for="confirmation2">
                        Je confirme ma déclaration de perte/vol
                    </label>
                </div>
            </div>
            @if (displayErrorMessage == true) {
                <div class="error-message">Ce champ est obligatoire. Veuillez choisir l'annulation ou la validation de
                    votre déclaration.
                </div>
            }
            <div class="row w-100 pt-3 text-center">
                <div class="col-12 w-100 cta_container">
                    <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                    @if (validation != '0') {
                        <button type="button" class="cta_btn level_2 column" (click)="setStep(2)">Suivant<span></span>
                        </button>
                    }
                    @if (validation == '0') {
                        <button type="button" class="cta_btn level_2 column" (click)="sendRequest()">
                            Valider<span></span></button>
                    }
                </div>
            </div>
        </div>
    </div>
}

@if (step == 2) {
    <div>
        <app-sim-choice
                [simChoiceInterface]="simChoiceInterface"
                [priceDetails]="priceDetails"
                [procedureCode]="procedureCode"
                [procedureStatus]="procedureStatus"
                [disableEsim]="true"
        ></app-sim-choice>
        <div class="card mt-3 border border-warning">
            <div class="card-body">
                <strong>En cas de vol de votre téléphone</strong>, nous pouvons le bloquer. Pour cela, vous devez
                déposer plainte en précisant :
                <br>
                - le numéro IMEI de votre téléphone portable
                <br>
                - que {{ brand == 'lacarte' ? 'SFR Discover' : brand | titlecase }} est votre opérateur
                <br>
                Vous avez ensuite 4 jours pour nous envoyer la déclaration de vol
                à {{ brand == 'lacarte' ? 'SFR Discover' : brand | titlecase }} – Service Client – 89515 VERON Cedex. À
                réception, nous procéderons au blocage de votre téléphone, ce qui le rendra <strong>définitivement
                inutilisable</strong>.
            </div>
        </div>
        <div class="row w-100 pt-3 text-center">
            <div class="col-12 w-100 cta_container">
                <button type="button" class="cta_cancel column" (click)="setStep(1)">Retour<span></span></button>
                @if (simChoiceInterface.simChoice == 4) {
                    <button type="button" class="cta_btn level_2 column" (click)="setStep(3)">Suivant<span></span>
                    </button>
                }
                @if (simChoiceInterface.simChoice == 7) {
                    <button type="button" class="cta_btn level_2 column" (click)="sendRequest()">Valider<span></span>
                    </button>
                }
            </div>
        </div>
    </div>
}
@if (step == 3 && simChoiceInterface.simChoice == 4 && shippingAddress) {
    <div>
        <div class="row w-100 pt-3 text-center margin-auto">
            <div class="col-12">
                <div class="civility-grid">
                    <span class="bold-label-text" style="text-align: justify;"><strong>Civilité*</strong></span>
                    <div class="input-grid">
                        <div>
                            <input type="radio" id="civility1" name="civility" [(ngModel)]="civility" value="Mr">
                            <label class="form-check-label" for="civility1">Monsieur</label>
                        </div>
                        <div>
                            <input type="radio" id="civility2" name="civility" [(ngModel)]="civility" value="Mme">
                            <label class="form-check-label" for="civility2">Madame</label>
                        </div>
                    </div>
                </div>
                <form [formGroup]="addressFrom" (submit)="sendRequest()">
                    <div class="form-group pb-2">
                        <span class="bold-label-text float-left">Nom*</span>
                        <input id="lastName" type="text" class="form-control" minlength="1" maxlength="35"
                               placeholder="Nom" formControlName="lastName" autocomplete="family-name" required>
                        @if (addressFrom.controls.lastName.errors) {
                            <small class="form-text error-message">{{ getError('lastName') }}</small>
                        }
                    </div>
                    <div class="form-group pb-2">
                        <span class="bold-label-text float-left">Prénom*</span>
                        <input id="firstName" type="text" class="form-control" minlength="1" maxlength="35"
                               placeholder="Prénom*" formControlName="firstName" autocomplete="given-name" required>
                        @if (addressFrom.controls.firstName.errors) {
                            <small class="form-text error-message">{{ getError('firstName') }}</small>
                        }
                    </div>
                    <div class="form-group pb-2">
                        <span class="bold-label-text float-left">Société</span>
                        <input id="company" type="text" class="form-control" maxlength="35" placeholder="Société"
                               formControlName="company" autocomplete="organization">
                        @if (addressFrom.controls.company.errors) {
                            <small class="form-text error-message">{{ getError('company') }}</small>
                        }
                    </div>
                    <div class="form-group pb-2">
                        <span class="bold-label-text float-left">Intitulé de l'adresse*</span>
                        <input id="label" type="text" class="form-control" minlength="1" maxlength="45"
                               placeholder="Domicile" formControlName="label" required>
                        @if (addressFrom.controls.label.errors) {
                            <small class="form-text error-message">{{ getError('label') }}</small>
                        }
                    </div>
                    <div class="form-group pb-2">
                        <span class="bold-label-text float-left">Rue*</span>
                        <input id="street" type="text" class="form-control" minlength="1" maxlength="45"
                               placeholder="Rue" formControlName="street" autocomplete="street-address" required>
                        @if (addressFrom.controls.street.errors) {
                            <small class="form-text error-message">{{ getError('street') }}</small>
                        }
                    </div>
                    <div class="form-group pb-2">
                        <span class="bold-label-text float-left">Complément d'adresse</span>
                        <input id="addressComplement" type="text" class="form-control" maxlength="45"
                               placeholder="Complément d'adresse" formControlName="addressComplement">
                        @if (addressFrom.controls.addressComplement.errors) {
                            <small class="form-text error-message">{{ getError('addressComplement') }}</small>
                        }
                    </div>
                    <div class="form-group pb-2">
                        <span class="bold-label-text float-left">Code postal*</span>
                        <input id="zipCode" type="text" class="form-control" minlength="1" maxlength="5"
                               placeholder="Code postal" formControlName="zipCode" autocomplete="postal-code" required>
                        @if (addressFrom.controls.zipCode.errors) {
                            <small class="form-text error-message">{{ getError('zipCode') }}</small>
                        }
                    </div>
                    <div class="form-group pb-2">
                        <span class="bold-label-text float-left">Ville*</span>
                        <input id="city" type="text" class="form-control" minlength="1" maxlength="45"
                               placeholder="Ville" formControlName="city" autocomplete="locality" required>
                        @if (addressFrom.controls.city.errors) {
                            <small class="form-text error-message">{{ getError('city') }}</small>
                        }
                    </div>
                    <div class="form-group pb-2 mb-4">
                        <span class="bold-label-text float-left">Lieu dit</span>
                        <input id="placeName" type="text" class="form-control" minlength="1" maxlength="45"
                               placeholder="Lieu dit" formControlName="placeName">
                        @if (addressFrom.controls.placeName.errors) {
                            <small class="form-text error-message">{{ getError('placeName') }}</small>
                        }
                    </div>
                    La carte SIM est généralement envoyée sous 48h et livrée sous 3 à 5 jours ouvrés. À réception,
                    rendez-vous dans la rubrique <strong>Gestion de ma ligne</strong> pour l'activer.
                    <br/><br/>
                    <div class="cta_container">
                        <button type="button" class="cta_cancel column" (click)="setStep(2)">Retour<span></span>
                        </button>
                        <button id="submit-button" type="submit" class="cta_btn level_2 column">Valider<span></span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
}
